import { type JSX } from 'react';

import { DocumentApi } from 'Api/Document/DocumentApi';
import { useCachedData } from 'Components/Context/CachedDataContext';
import { ColumnConfig, ColumnType } from 'Components/Table/Columns';
import { Table } from 'Components/Table/Table';
import { ManualEvidence } from 'Models/ControlEvidence';
import { numberAsEffectivenessString } from 'Models/OperationalControls';

export interface ControlEvidenceListingProps {
    documentApi: DocumentApi;
    hideModal: () => void;
    manualEvidenceList: ManualEvidence[];
}

export const ControlEvidenceListing = (props: ControlEvidenceListingProps): JSX.Element => {
    const cachedData = useCachedData();

    const columns: ColumnConfig<ManualEvidence>[] = [
        {
            type: ColumnType.USER,
            name: 'Submitter',
            getUserId: (evidence) => evidence.submitter_subject,
            users: cachedData.users,
        },
        {
            type: ColumnType.DATE,
            name: 'Date',
            getDateString: (evidence) => evidence.metric_timestamp,
        },
        {
            type: ColumnType.FILE,
            name: 'File Name',
            documentApi: props.documentApi,
            getFile: (evidence) => evidence.file,
        },
        {
            type: ColumnType.STRING,
            name: 'Link',
            getString: (evidence) => (evidence.external_url ? 'Link' : undefined),
            getOnClickTextAction: (evidence) => (evidence.external_url ? { goToLocation: evidence.external_url, isExternalUrl: true } : undefined),
        },
        {
            type: ColumnType.STRING,
            name: 'Comment',
            getString: (evidence) => evidence.evidence_comment,
        },
        {
            type: ColumnType.STRING,
            name: 'Effectiveness',
            getString: (evidence) => (evidence.evidence_effectiveness ? numberAsEffectivenessString(evidence.evidence_effectiveness) : undefined),
        },
    ];

    return <Table<ManualEvidence> columns={columns} defaultSortColumn="Date" defaultSortDirection="descending" filters={[]} getUniqueIdForRow={(evidence) => `${evidence.submitter_subject}-${evidence.metric_timestamp}`} rowsData={props.manualEvidenceList} />;
};
